import { GoScreenFull } from "react-icons/go";
import { IoMdNotificationsOutline } from "react-icons/io";
import "./Header.css";
import { useState, useEffect } from "react";
import Logout from "../Popup/Logout";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { CiLogin } from "react-icons/ci";
import axiosInstance from "../axiosinstance";

function Header({ isSidebarExpanded }) {
  const [username, setUsername] = useState("");
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const navigate = useNavigate(); // Initialize navigate

  const currentHour = new Date().getHours();

  const getGreeting = () => {
    if (currentHour < 12) return "Good Morning";
    if (currentHour < 18) return "Good Afternoon";
    return "Good Evening";
  };

  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const response = await axiosInstance.get(`/api/get_user_name`);
        setUsername(response.data.user_name);
      } catch (error) {
        console.error("Error fetching username:", error);
      }
    };

    fetchUserName();
  }, []);

  const clearAuthStorage = () => {
    localStorage.removeItem("authKey");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    localStorage.removeItem("user_role");
  };

  const handleLogout = async () => {
    const refreshToken = localStorage.getItem("refresh_token");

    console.log("Logout initiated");
    
    

    // Try to notify server first (before clearing storage)
    if (refreshToken) {
      try {
        console.log("Sending logout request");
        await axiosInstance.post(`/api/logout`, {
          refresh_token: refreshToken,
        });
        console.log("Server logout successful");
      } catch (error) {
        console.error(
          "Server logout failed:",
          error.response?.data || error.message
        );
        // Continue with local logout anyway
      }
    } else {
      console.warn(
        "No refresh token found in localStorage, skipping server logout"
      );
    }

    clearAuthStorage();
    window.dispatchEvent(new Event("app:logout"));
    console.log("Auth storage cleared");

    // Navigate to login
    navigate("/login");
  };

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement
        .requestFullscreen()
        .then(() => setIsFullScreen(true))
        .catch((err) => console.error("Error attempting fullscreen:", err));
    } else {
      document
        .exitFullscreen()
        .then(() => setIsFullScreen(false))
        .catch((err) => console.error("Error exiting fullscreen:", err));
    }
  };

  return (
    <div
      className={`heading-container ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="heading-container-content">
        <div className="heading-left">
          <div className="greeting">
            Hello, {getGreeting()} <span className="user-name">{username}</span>
          </div>
        </div>
        <div className="heading-right">
          {/* <div className="icon-container" onClick={toggleFullScreen}>
            <span
              className="header-icon"
              title={isFullScreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              <GoScreenFull color="black" size={20} />
            </span>
          </div> */}
          {/* <div className="icon-container">
            <span className="header-icon">
              <IoMdNotificationsOutline color="black" />
            </span>
          </div> */}
          {/* <div className="icon-container" onClick={handleLogout}>
            <svg
              stroke="currentColor"
              fill="none"
              strokeWidth="2"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="log-out-icon"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" x2="9" y1="12" y2="12"></line>
            </svg>
          </div> */}
          <div className="icon-container" onClick={handleLogout}>
            <span className="header-icon">
              <CiLogin color="black" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;

